import { slideToggle, toggleAria } from "../utils.js";
import "core-js/es/array";

export default class Content {
  constructor() {
    this.showMenuBtns = Array.from(
      document.querySelectorAll(".js-content-navbtn")
    );

    if (this.showMenuBtns) this.init();

    //this.sidebar = document.querySelector(".c-blog-sidebar");
    //this.sidebarInView = true;
    //this.breakoutElements = document.querySelectorAll(".c-breakout, .c-f");

    //if (this.sidebar) {
    //  window.addEventListener("scroll", this.toggleFade.bind(this));
    //}
  }

  init() {
    this.showMenuBtns.forEach((btn) =>
      btn.addEventListener("click", (ev) => {
        const hiddenEl = btn.nextElementSibling;

        console.log(hiddenEl);

        btn.classList.toggle("active");
        toggleAria(btn, "aria-expanded");

        if (!hiddenEl) return;

        slideToggle(hiddenEl, 300);
      })
    );

    const params = new URLSearchParams(window.location.search);

    if (params.has("sq")) {
      var markBody = new Mark(document.querySelector(".body"));
      var markBanner = new Mark(document.querySelector(".c-banner__content"));

      markBody.mark(params.get("sq"), {
        element: "span",
        className: "highlight",
      });

      markBanner.mark(params.get("sq"), {
        element: "span",
        className: "highlight-banner",
      });
    }
  }

  /*   toggleFade() {
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    var sidebarTop =
      scrollTop +
      this.sidebar.getBoundingClientRect().top +
      this.sidebar.clientHeight;
    var elem;
    var distInView;

    if (this.sidebarInView) {
      for (var i = 0; i < this.breakoutElements.length; i++) {
        elem = this.breakoutElements[i];
        distInView =
          sidebarTop - (scrollTop + elem.getBoundingClientRect().top);

        if (distInView < 0) {
          distInView =
            sidebarTop -
            (scrollTop +
              elem.getBoundingClientRect().bottom +
              this.sidebar.clientHeight);

          if (distInView > 0) {
            this.sidebarInView = false;
            this.sidebar.dataset.breakout = i;
            break;
          }
        } else {
          distInView =
            sidebarTop -
            (scrollTop +
              elem.getBoundingClientRect().bottom +
              this.sidebar.clientHeight);
          if (distInView < 0) {
            this.sidebarInView = false;
            this.sidebar.dataset.breakout = i;
            break;
          }
        }
      }

      if (this.sidebarInView) {
        this.sidebar.classList.add("in-view");
      } else {
        this.sidebar.classList.remove("in-view");
      }
    } else {
      if (this.sidebar.dataset.breakout == undefined) this.sidebarInView = true;

      elem = this.breakoutElements[this.sidebar.dataset.breakout];
    distInView =
        sidebarTop -
        (scrollTop +
          elem.getBoundingClientRect().bottom +
          this.sidebar.clientHeight);

      if (distInView > 0) {
        this.sidebar.classList.add("in-view");
        this.sidebarInView = true;
      } else {
        distInView =
          sidebarTop - (scrollTop + elem.getBoundingClientRect().top);

        if (distInView < 0) {
          this.sidebar.classList.add("in-view");
          this.sidebarInView = true;
        }
      }
    }
  } */
}
